import React from "react";
import getClassNames from "./classnames";
import PropTypes from "prop-types";
/*istanbul ignore next */
function Tag(props) {
  const { text, remove, disabled, className } = props;

  const handleOnRemove = (e) => {
    e.stopPropagation();
    remove(text);
  };

  return (
    <span className={getClassNames("rti--tag", className)}>
      <span>{text}</span>
      {!disabled && (
        <button
          type="button"
          onClick={handleOnRemove}
          aria-label={`remove ${text}`}
        >
          &#10005;
        </button>
      )}
    </span>
  );
}

Tag.propTypes = {
  text: PropTypes.string.isRequired,
  remove: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Tag.defaultProps = {
  disabled: false,
  className: "",
};

export default Tag;
